import { render, staticRenderFns } from "./EmbeddingConfig.vue?vue&type=template&id=3d11d288&"
import script from "./EmbeddingConfig.vue?vue&type=script&lang=js&"
export * from "./EmbeddingConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d11d288')) {
      api.createRecord('3d11d288', component.options)
    } else {
      api.reload('3d11d288', component.options)
    }
    module.hot.accept("./EmbeddingConfig.vue?vue&type=template&id=3d11d288&", function () {
      api.rerender('3d11d288', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/googleSheet/components/EmbeddingConfig.vue"
export default component.exports